import LawUpdatesBlock from './LawUpdatesBlock';

export default LawUpdatesBlock;
